export const LINNER_ITEMS = [
    {
        filename: 'nonstarch-asparagus_half',
        name: 'Asparagus',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'Asparagus is a good choice for your plate, but you want to make sure you fill half your plate with it. Try again.',
        messageRight: 'Wonderful! Asparagus is a perfect non-starchy food to put on your plate.'
    },
    {
        filename: 'nonstarch-broccoli_half',
        name: 'Broccoli',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'Even though you put broccoli on your plate, you want to fill half your plate with non-starchy foods, not just a quarter. Try again.',
        messageRight: 'Great job! Broccoli is a good non-starchy choice for your plate. Keep it up!'
    },
    {
        filename: 'nonstarch-carrotmix_half',
        name: 'Carrot Mix',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'I know it may seem like you only need a little, but non-starchy foods like carrots and wax beans should fill half your plate. Try again.',
        messageRight: 'Well done! Non-starchy foods like carrots and wax beans should fill half your plate.'
    },
    {
        filename: 'nonstarch-salad_half',
        name: 'Salad',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'Salad is an excellent way to fill your plate with non-starchy foods. Try filling half your plate next time.',
        messageRight: 'Great! Salad is the perfect way to fill half your plate. You can always chop up your quarter-plate of protein to put on top as well.'
    },
    {
        filename: 'nonstarch_cucumber_half',
        name: 'Cucumber',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'I know it may seem like a lot, but you should try to fill half your plate if you choose to eat cucumber. Try again.',
        messageRight: 'Nice job! If it seems like eating half a plate of cucumber is too daunting, try mixing it with some greens in a salad to fill half the plate.'
    },
    {
        filename: 'protein-chicken_qt',
        name: 'Chicken',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: 'It may be hard to resist the temptation to load your plate with meat, but you should limit your protein to a quarter of your plate. Try again.',
        messageRight: `Good! A quarter of your plate should contain a protein such as chicken. That's the perfect portion size.`
    },
    {
        filename: 'protein-beef_qt',
        name: 'Beef',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: 'It may be hard to resist the temptation to load your plate with meat, but you should limit your protein to a quarter of your plate. Try again.',
        messageRight: `Good! A quarter of your plate should contain a protein such as beef. That's the perfect portion size.`
    },
    {
        filename: 'protein-fish_qt',
        name: 'Fish',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: 'It may be hard to resist the temptation to load your plate with meat, but you should limit your protein to a quarter of your plate. Try again.',
        messageRight: `Good! A quarter of your plate should contain a protein such as salmon or tuna. That's the perfect portion size.`
    },
    {
        filename: 'protein-pork_qt',
        name: 'Pork',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: 'It may be hard to resist the temptation to load your plate with meat, but you should limit your protein to a quarter of your plate. Try again.',
        messageRight: `Good! A quarter of your plate should contain a protein such as pork. That's the perfect portion size.`
    },
    {
        filename: 'protein-tofu_qt',
        name: 'Tofu',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: 'It may be hard to resist the temptation to load your plate with meat, but you should limit your protein to a quarter of your plate. Try again.',
        messageRight: `Good! A quarter of your plate should contain a protein such as tofu or another non-meat protein if you don't eat meat.`
    },
    {
        filename: 'starch-blackbeans_qt',
        name: 'Black Beans',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `That's a lot of beans! Black beans are actually a starch and should be limited to a quarter of your plate. Try again.`,
        messageRight: `Perfect! Black beans, while good for you, are also a starchy food that should be limited to a quarter of your plate.`
    },
    {
        filename: 'starch-bread_qt',
        name: 'Bread',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Bread is a starchy food that you should definitely try to limit to a quarter of your plate, and you should stick to whole grains when you can. Try again.`,
        messageRight: `Great! Limiting bread to a quarter of your plate is recommended. Also, go for breads made with whole grains.`
    },
    {
        filename: 'starch-mash_qt',
        name: 'Potatoes',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Starchy foods like potatoes can be an easy food to make, but be sure to limit it to only a quarter of your plate. Try again.`,
        messageRight: `Nice job! Though potatoes are an easy food to add to your meal, you definitely want to limit it to a quarter of your plate.`
    },
    {
        filename: 'starch-pasta_qt',
        name: 'Pasta',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Pasta is an easy food to overload on your plate. Make sure you limit it to only a quarter of your plate and go for whole grain pasta if you can. Try again.`,
        messageRight: `Wonderful! If you're going to eat pasta, try to go for whole grain pasta if you can.`
    },
    {
        filename: 'starch-peas_qt',
        name: 'Peas',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `While peas are a healthy food, you don't want to go too heavy. They're considered a starchy food you should limit to a quarter of your plate. Try again.`,
        messageRight: `Good job! Peas are an excellent food to add to your meal as long as you limit it to a quarter of your plate.`
    },
    {
        filename: 'starch-sweetpotato_qt',
        name: 'Sweet Potato',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Sweet potatoes are packed with vitamins, but they're still a starchy food. Try to limit to 1/4 of your plate. Try again.`,
        messageRight: `Perfect! Sweet potatoes are packed with vitamins and minerals.`
    },
    {
        filename: 'starch-bakedpotato_qt',
        name: 'Baked Potato',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Potatoes are a good source of vitamins and minerals, but they're still a starchy food. Try to limit to 1/4 of your plate. Try again.`,
        messageRight: `Great! Limiting potatoes to a quarter of your plate is recommended.`
    },
    {
        filename: 'starch-roll_qt',
        name: 'Roll',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Starchy foods like rolls can be an easy food to make, but be sure to limit it to only a quarter of your plate. Try again.`,
        messageRight: `Nice job! Though rolls are an easy food to add to your meal, you definitely want to limit it to a quarter of your plate.`
    },
    {
        filename: 'starch-corn_qt',
        name: 'Corn on the Cob',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Corn is a delicious side to any meal, but you want to be mindful of the sugar content. If it's on the cob, try cutting it in half. Try agin.`,
        messageRight: `Great! Eating a smaller ear of corn or cutting a large one in half is a great way to manage portions.`
    },

    // Fruits and Drinks
    {
        filename: 'fruit-juice',
        name: 'Fruit Juice',
        foodType: 'Sugary Drink',
        correctPortion: '',
        messageWrong: 'Fruit juices like orange juice are a great source of Vitamin C, but you should be careful due to its sugar content. Try again without having a cookie or fruit on the side.',
        messageRight: `Good! Fruit juices like orange juice are a great source of Vitamin C, but just make sure you don't have it with a piece of fruit or a sweet like cookies.`
    },
    {
        filename: 'milk',
        name: 'Milk',
        foodType: 'Mild Sugary Drink',
        correctPortion: '',
        messageWrong: `You may be surprised to know that milk has its own sugars. While it is natural, you shouldn't combine it with cookies as tempting as it may be. Try again.`,
        messageRight: `Great! Dietary guidelines suggest having a glass of milk and piece of fruit with your meal is the best combination.`
    },
    {
        filename: 'sugar-free-soda',
        name: 'Sugar-Free Soda',
        foodType: 'Sugar-Free Drink',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Sugar-free drinks that use artificial sweeteners instead of sugar are a fine choice for any occasion, though we recommend milk or water whenever possible.`
    },
    {
        filename: 'water',
        name: 'Water',
        foodType: 'Water',
        correctPortion: '',
        messageWrong: `While it's not wrong to have water with your meal, we suggest having milk and a piece of fruit if you can. Stick to water if you're having a sweet dessert like a cookie.`,
        messageRight: `Yes! You can have water with your meal if you plan on having something sweet like a cookie. We recommend milk and a piece of fruit otherwise.`
    },
    {
        filename: 'apple',
        name: 'Apple',
        foodType: 'Fruit',
        correctPortion: '',
        messageWrong: `While fruit may seem like a perfect choice, you definitely don't want to combine it with something like fruit juice.`,
        messageRight: `Great! Having a piece of fruit alongside your meal is a good choice, especially with a glass of milk.`
    },
    {
        filename: 'cookie',
        name: 'Cookie',
        foodType: 'Dessert',
        correctPortion: '',
        messageWrong: `Be careful with desserts and sweets like cookies. If you want a cookie with your meal, replace your drink with water or sugar-free soda.`,
        messageRight: `Having a cookie with your meal is okay. Just make sure you have it with water or sugar-free soda to limit the amount of sugar you're consuming.`
    },
    {
        filename: 'coffee',
        name: 'Coffee',
        foodType: 'Sugar-Free Drink',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Coffee is fine with breakfast. Just make sure you're careful about adding sugar. Drink black or with some cream.`
    },
    {
        filename: 'banana',
        name: 'Banana',
        foodType: 'Fruit',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Great! Having a piece of fruit alongside your meal is a good choice, especially with a glass of milk.`
    },
    {
        filename: 'yogurt',
        name: 'Yogurt',
        foodType: 'Dairy',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Yogurt is a fine choice, but just make sure it doesn't have extra sugar content. Choose a Greek yogurt or one sweetened with sucralose.`
    },
    {
        filename: 'icecream',
        name: 'Ice Cream',
        foodType: 'Dessert',
        correctPortion: '',
        messageWrong: `Due to the sugar content of ice cream, you want to be mindful not to drink it with milk or juice. Try again.`,
        messageRight: `Ice cream is an okay treat on occasion. Just make sure you stick to a scoop and don't add extra sugary toppings.`
    },
]
